import * as React from "react";
import { CollapsableItem } from "../../molecules/CollapsableItem";
import { ResponsiveWidget } from "../../components/ResponsiveWidget";
import { PropValuesEnum, FAQHeader } from "../../constants/commons";
import { useIsMobile, useIsTab } from "../../hooks/useIsMobile";
import { useSTR } from "react-str";
import { URL } from "../../API/urlEndpoints";
import { postData } from "../../utils/fetchers";
import { ErrorComponent } from "../../molecules/ErrorComponent";

export enum FAQCategoryEnum {
  FITNESS = "Fitness",
  YOGA = "Yoga",
  THERAPIST = "Therapists & Psychiatrist",
  NUTRITIONIST = "Nutritionists",
  DOCTOR = "Doctor",
  PSYCHIATRIST = "Therapists & Psychiatrist",
  PHYSIOTHERAPIST = "Physiotherapist",
  JOINING_PARTNER_FIT = "Joining Partner.fit",
  SCHEDULING_CUSTOMER_SESSIONS = "Scheduling Customer Sessions",
  PAYMENTS = "Payments",
}

interface FAQProps {
  categories?: Array<FAQCategoryEnum>;
}

export const FAQ: React.FunctionComponent<FAQProps> = (props) => {
  const isMobile = useIsMobile();
  const isTablet = useIsTab();
  const categories = props.categories || [];
  const [faqSection, setFaqSection] = React.useState<Array<any>>([]);

  const [
    ,
    {
      result: getFAQDataResult,
      revalidator: refetchFAQData,
      loading: FAQDataisLoading,
      error: getFAQDataError,
    },
  ] = useSTR(postData);

  React.useEffect(() => {
    refetchFAQData(`${URL.getFAQDetails}`, { categories: categories });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (!FAQDataisLoading && getFAQDataResult) {
      setFaqSection(getFAQDataResult);
    }
  }, [FAQDataisLoading, getFAQDataResult]);

  const renderFaqData = () => {
    return faqSection.map((faqdata, key) => {
      const { heading, description, data } = faqdata;
      return (
        <div
          key={key}
          className={`col-12 col-sm-6 col-md-4  ${
            isMobile || isTablet ? "my-2" : "my-3"
          }`}
        >
          <ResponsiveWidget
            align={PropValuesEnum.VERTICAL}
            className="data-container"
          >
            <CollapsableItem
              heading={heading}
              description={description}
              data={data}
            />
          </ResponsiveWidget>
        </div>
      );
    });
  };

  return (
    <React.Fragment>
      {FAQDataisLoading && <div className="loader" />}
      {getFAQDataError && <ErrorComponent errorObj={getFAQDataError} />}
      {!FAQDataisLoading && !!faqSection.length && (
        <React.Fragment>
          <div className="header-container mb-3 w-100">
            <h5>{FAQHeader}</h5>
          </div>
          <div className="row">{renderFaqData()}</div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
